import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
export const HorizontalScrollContext = createContext({
    dataTest: 'horizontal-scroll',
});
export const HorizontalScrollProvider = ({ dataTest, children }) => {
    return (_jsx(HorizontalScrollContext.Provider, { value: { dataTest }, children: children }));
};
export const useHorizontalScrollContext = () => {
    const value = useContext(HorizontalScrollContext);
    if (value === undefined) {
        throw new Error('useHorizontalScrollContext must be used within a HorizontalScrollProvider');
    }
    return value;
};
